import React, { useEffect, useState } from "react";
import { Card } from "antd";
import SideBar, { routes } from "./sidebar";
import { Row, Col } from "reactstrap";

import { Firestore } from "../../config/firebase";

export default function Admin() {
  const [users, setUsers] = useState([]);
  const [updates, setUpdates] = useState([]);
  const [allProducts, setAllproducts] = useState([]);

  useEffect(() => {
    var usersRef = Firestore.collection("users");
    var updatesRef = Firestore.collection("updates");
    var allProductsRef = Firestore.collection("allProducts");

    usersRef.get().then(function (querySnapshot) {
      let docs = [];
      querySnapshot.forEach(function (doc) {
        docs.push(doc.data());
        // doc.data() is never undefined for query doc snapshots

        setTimeout(() => {
          setUsers(docs);
        }, 1000);
      });
    });

    updatesRef.get().then(function (querySnapshot) {
      let docs = [];
      querySnapshot.forEach(function (doc) {
        docs.push(doc.data());
        // doc.data() is never undefined for query doc snapshots

        setTimeout(() => {
          setUpdates(docs);
        }, 1000);
      });
    });

    allProductsRef.get().then(function (querySnapshot) {
      let docs = [];
      querySnapshot.forEach(function (doc) {
        docs.push(doc.data());
        // doc.data() is never undefined for query doc snapshots

        setTimeout(() => {
          setAllproducts(docs);
        }, 1000);
      });
    });
  }, []);

  return (
    <>
      <Row>
        <Col>
          <Card>
            <h1>{users.length}</h1>
            <b className="text-bold">USERS</b>
          </Card>
        </Col>

        <Col>
          <Card>
            <h1>{updates.length}</h1>
            <b className="text-bold text-uppercase">Grants</b>
          </Card>
        </Col>

        <Col>
          <Card>
            <h1>{allProducts.length}</h1>
            <b className="text-bold text-uppercase">All Products</b>
          </Card>
        </Col>
      </Row>

      <Card className="mt-3">
        All products
        <hr />
      </Card>
    </>
  );
}
